<template>
    <div v-if="categoria" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes da Categoria de Plano</h4>
        <router-link to="/cadastros/categorias-de-planos">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <!-- Seção 1 -->
        <FormSection title="">
          <p><strong>Nome:</strong> {{ categoria.nome || 'Não informado' }}</p>
          <p><strong>Ativo:</strong> {{ verificarAtivo(categoria?.ativo) }}</p>
        </FormSection>
  
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { FormSection },
    data() {
      return {
        categoria: null,
      };
    },
    methods: {
      async carregarDetalhesCategoria() {
        try {
          const response = await axios.get(
            `/cadastros/categorias-de-planos/${this.$route.params.id}`
          );
          this.categoria = response.data;
        } catch (error) {
          console.error("Erro ao carregar os detalhes da categoria:", error);
        }
      },
  
      verificarAtivo(valor) {
        if (valor === undefined || valor === null) {
          return "Não informado";
        }
        return valor ? "Ativo" : "Inativo";
      },
    },
    mounted() {
      this.carregarDetalhesCategoria();
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%; /* Ajustado para centralizar melhor */
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  
  .form-content {
    margin-top: 1.5rem;
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
